
import Vue from 'vue'
import { NumberSpinner } from '@/components/input'

export default Vue.extend({
   name: 'NumberSpinnerFormGroup',
   props: {
      id: String,
      label: String,
      value: { type: Number, default: 0 },
      offset: { type: Number, default: 0 },
      placeholder: { type: String, default: '' },
      required: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      validate: { type: Boolean, default: false },
      instructions: { type: String, default: '' },
   },
   data() {
      return {
         initialValue: 0,
         innerValue: 0,
         dirty: false,
      }
   },
   computed: {
      validationFailed(): boolean {
         if (!this.required) {
            return false
         }
         if (!this.validate && !this.dirty) {
            return false
         }
         return !this.innerValue
      },

      helpBlock(): string {
         return `A value for ${this.label} is required`
      },
   },
   mounted() {
      this.innerValue = this.value
      this.initialValue = this.value
   },
   watch: {
      value(newValue: number) {
         if (newValue !== this.innerValue) {
            this.innerValue = newValue
            this.initialValue = newValue
         }
      },
   },
   methods: {
      onChange() {
         if (!this.dirty) {
            this.dirty = this.innerValue !== this.value
         }
         this.$emit('input', this.innerValue)
      },
   },
   components: {
      NumberSpinner,
   },
})
